import { z } from 'zod'

export const GoogleDistanceMatrixElementZod = z.object({
  duration: z.object({
    // indicates the duration in seconds.
    value: z.number(),
    text: z.string(),
  }),
  duration_in_traffic: z
    .object({
      // indicates the duration in seconds.
      value: z.number(),
      text: z.string(),
    })
    .optional(),
  distance: z.object({
    // indicates the distance in meters.
    value: z.number(),
    text: z.string(),
  }),
})
